import React from 'react';
 
const DynamicMOU = ({ vendorData }) => {
  if (!vendorData) return <div>Fill Onboarding Form</div>;
 
  return (
    <div>
      <p><strong>MEMORANDUM OF UNDERSTANDING</strong></p>
      <p>This Memorandum of Understanding ("MoU") is entered into on <strong>{new Date().toLocaleDateString()}:</strong></p>
      
      <p><strong>BY AND BETWEEN</strong></p>
      <p><strong>Drone Planet</strong>, a Startup Stairs Pvt. Ltd., a company registered under the laws of India, with its registered office at Plot 251, Phase IV, Udyog Vihar, Gurugram (hereinafter referred to as "Marketplace" or "First Party")</p>
      
      <p>AND</p>
      
      <p><strong>{vendorData.modelNo}</strong>, a business entity registered under the laws of India, with its registered office at {vendorData.address} (hereinafter referred to as "Vendor" or "Second Party")</p>
      
      <p>Both the First Party and Second Party are herein collectively referred to as the "Parties" and individually as a "Party".</p>
 
        <p><strong>1. PURPOSE</strong></p>
        <p>The purpose of this MoU is to establish the terms and conditions under which the Vendor shall sell drones and spare parts on the Marketplace, while the Marketplace shall facilitate the sale of these products through its platform.</p>
 
        <p><strong>2. DURATION OF THE MOU</strong></p>
        <p>This MoU shall become effective as of the date above and shall continue for [Specify Duration] year(s), unless terminated earlier by either party with thirty (30) days' written notice.</p>
 
        <p><strong>3. SCOPE OF THE AGREEMENT</strong></p>
        <p>a. Products: Sale of drones and spare parts. <br />b. Vendor: Compliance with Indian laws, certifications, approvals. <br />c. Marketplace: Provide platform access, marketing, and support.</p>
 
        <p><strong>4. COMMISSION RATES</strong></p>
        <p>a. Drones: 10% commission <br />b. Spare parts: 15% commission <br />c. Payout: Within 15 business days post-sale <br />d. Monthly processing <br />e. Dashboard access for transparency</p>
 
        <p><strong>5. VENDOR OBLIGATIONS</strong></p>
        <p>Accurate listings, legal compliance, timely dispatch, after-sales service, and adequate stock maintenance.</p>
 
        <p><strong>6. MARKETPLACE OBLIGATIONS</strong></p>
        <p>Platform listing, promotional support, customer service, and product approval rights.</p>
 
        <p><strong>7. PRODUCT LISTINGS AND PRICING</strong></p>
        <p>Vendor controls pricing, Marketplace may run promotions with prior notice of changes required.</p>
 
        <p><strong>8. RETURNS AND REFUNDS</strong></p>
        <p>Vendor adheres to return policy, bears return costs unless otherwise agreed in writing.</p>
 
        <p><strong>9. DELIVERY TERMS</strong></p>
        <p>Vendor responsible for packaging, shipping, tracking, delivery updates, and refund obligations.</p>
 
        <p><strong>10. TERMINATION</strong></p>
        <p>30-day notice for termination. Immediate termination for breach or unlawful activity.</p>
 
        <p><strong>11. CONFIDENTIALITY</strong></p>
        <p>Confidential info includes financials, specs, and customer data. Survives 2 years post-termination.</p>
 
        <p><strong>12. DISPUTE RESOLUTION</strong></p>
        <p>Negotiation, then arbitration under the Indian Arbitration Act. Venue: New Delhi. Language: English.</p>
 
        <p><strong>13. GOVERNING LAW</strong></p>
        <p>Governing Law: India</p>
 
        <p><strong>14. MISCELLANEOUS</strong></p>
        <p>a. Written amendments only. <br />b. Entire agreement. <br />c. No joint venture or partnership.</p>
 
        <p><strong>15. SIGNATURES</strong></p>
        <p>IN WITNESS WHEREOF, the Parties have executed this MoU on the date mentioned above.</p>
        <p><strong>For Startup Stairs Pvt. Ltd.</strong></p>
        <p>Name: ____________________ <br />Title: ____________________ <br />Date: ____________________</p>
      
      <p><strong>For {vendorData.modelNo}</strong></p>
      <p>Name: {vendorData.name}<br />
      Title: Authorized Signatory<br />
      Date: {new Date().toLocaleDateString()}</p>
 
      <hr />
        <p><strong>📎 LIST OF REQUIRED DOCUMENTS FOR VENDOR ONBOARDING</strong></p>
        <p><strong>1. Business Registration Documents</strong></p>
        <p>- Certificate of Incorporation / Business License<br />- Partnership Deed (if applicable)<br />- GST/VAT/TIN registration<br />- MSME Certificate (if applicable)<br />- PAN Card</p>
 
        <p><strong>2. Banking and Financial Information</strong></p>
        <p>- Bank Account details with canceled cheque<br />- Tax Identification Number<br />- Financial Statements (if required)</p>
 
        <p><strong>3. Compliance & Regulatory</strong></p>
        <p>- Required licenses/permits<br />- Data Protection agreements (if applicable)</p>
 
        <p><strong>4. Contracts</strong></p>
        <p>- Vendor Agreement<br />- NDA</p>
 
        <p><strong>5. Product Documentation</strong></p>
        <p>- Product listings and certifications</p>
 
        <p><strong>6. References (optional)</strong></p>
        <p>- Client references / testimonials</p>
 
        <p><strong>7. Tax Compliance Certificates</strong></p>
        <p>- Tax Residency Certificate<br />- Tax Clearance Certificate</p>
    </div>
  );
};
 
export default DynamicMOU;